
<template>
  <div class="text-xs-center">
         <span class="black--text" v-if="$mq!='mobile'">
          Hi {{User.first_name}} &nbsp;</span>
    <v-menu offset-y style="cursor:pointer">
       <img  width="19" height="20" slot="activator" :src="userImage" />
        <div class="black--text pa-2 " style="width:200px" v-if="$mq=='mobile'">
       
          {{User.first_name}}</div>
       
      <v-list style="min-width=100px">
          <v-divider v-if="$mq=='mobile'" />
         <v-list-tile
          v-for="(item, index) in items"
          :key="index"
          @click="showProfile(item)"
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
  export default {
    data: () => ({
      userImage:require('@/assets/user-profile.svg'),
      User: {
          first_name:"",
          id:0
      },
      items: [
        { title: 'Profile' },
        { title: 'Logout' }
      ]
    }),
    mounted:function() {
        var $options={}
         $options= JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE))
         //console.log($options)
         this.$store.commit('SET_USER_INFO',$options.data.User)
        // this.User =$options.data.User;
        //console.log(this.$store)
        this.User=this.$store.getters.userInfo
      //  alert(JSON.stringify(this.User,null,4))     
    },
    methods: {
        showProfile(item) {
            if(item.title=='Profile') {
            this.$router.push("/user/edit?id="+this.User.id)
            } else {
              this.$router.push("/logout")
            }
        }
    }
  }
</script>